import {SoundManager} from '@fantasmagames/slot/src/sound/SoundManager';

export class GameSoundManager extends SoundManager {
	protected initVolumes(): void {
	}

	protected initEffects(): void {
		super.initEffects();

		// ---- HOOKED UP
		this._effects.buttonClick = this.loader.getSound('resources/sounds/btn_general.mp3');
		this._effects.spinBtnStart = this.loader.getSound('resources/sounds/btn_spin_start.mp3');

		this._effects.gameIntro = this.loader.getSound('resources/sounds/trans_game_intro.mp3');

		this._effects.reelsFallOut = this.loader.getSound('resources/sounds/reels_fall_out.mp3');
		this._effects.reelsFallIn = this.loader.getSound('resources/sounds/reels_fall_in.mp3');
		this._effects.reelsFallIn3sec = this.loader.getSound('resources/sounds/reels_fall_in_3sec.mp3');
		this._effects.reelsRemove = this.loader.getSound('resources/sounds/reels_remove.mp3');

		this._effects.winLineL = this.loader.getSound('resources/sounds/win_indicate_lr.mp3');
		this._effects.winLineR = this.loader.getSound('resources/sounds/win_indicate_rl.mp3');
		this._effects.winCountup = this.loader.getSound('resources/sounds/win_countup.mp3');
		this._effects.winNormal = this.loader.getSound('resources/sounds/win_normal.mp3');
		this._effects.winNice = this.loader.getSound('resources/sounds/win_nice.mp3');
		this._effects.winExcellent = this.loader.getSound('resources/sounds/win_excellent.mp3');
		this._effects.winRetrigger = this.loader.getSound('resources/sounds/win_retrigger.mp3');

		this._effects.bigwinBuildup = this.loader.getSound('resources/sounds/win_bigwin_buildup.mp3');
		this._effects.bigwinLoop = this.loader.getSound('resources/sounds/music/win_bigwin_loop.mp3');
		this._effects.bigwinEnd = this.loader.getSound('resources/sounds/win_bigwin_end.mp3');
		this._effects.bigwinThreshold = this.loader.getSound('resources/sounds/win_bigwin_threshold.mp3');

		this._effects.multCollectFly = this.loader.getSound('resources/sounds/mult_collect_fly.mp3');
		this._effects.multCollectHit = this.loader.getSound('resources/sounds/mult_collect_hit.mp3');
		this._effects.multUpdate = this.loader.getSound('resources/sounds/mult_update.mp3');
		this._effects.multUpdateFs = this.loader.getSound('resources/sounds/mult_update_fs.mp3');
		this._effects.multWildBreak = this.loader.getSound('resources/sounds/mult_wildbreak.mp3');
		this._effects.multWin = this.loader.getSound('resources/sounds/mult_win.mp3');

		this._effects.respinAttention = this.loader.getSound('resources/sounds/atn_respin.mp3');
		this._effects.respinActivate = this.loader.getSound('resources/sounds/rsp_activate.mp3');
		this._effects.respinMove = this.loader.getSound('resources/sounds/rsp_move.mp3');
		this._effects.respinHit1 = this.loader.getSound('resources/sounds/rsp_hit01.mp3');
		this._effects.respinHit2 = this.loader.getSound('resources/sounds/rsp_hit02.mp3');
		this._effects.respinHit3 = this.loader.getSound('resources/sounds/rsp_hit03.mp3');
		this._effects.respinEnd = this.loader.getSound('resources/sounds/rsp_end.mp3');

		this._effects.scatterAttention1 = this.loader.getSound('resources/sounds/atn_scatter_1.mp3');
		this._effects.scatterAttention2 = this.loader.getSound('resources/sounds/atn_scatter_2.mp3');
		this._effects.scatterAttention3 = this.loader.getSound('resources/sounds/atn_scatter_3.mp3');

		this._effects.freeSpinsIntro = this.loader.getSound('resources/sounds/trans_fs_intro.mp3');
		this._effects.freeSpinsOutro = this.loader.getSound('resources/sounds/trans_fs_outro.mp3');
		// ----

		// TODO: Remove if quickstop isn't used.
		this._effects.spinBtnQuickStop = this.loader.getSound('resources/sounds/btn_spin_stop.mp3');

		// TODO: Implement when correct respin attention logic is in place.

		// TODO: Implement when correct behavior is in place
		this._effects.multCollectIndicator = this.loader.getSound('resources/sounds/mult_collect_indicator.mp3');
	}

	protected initMusic(): void {
		super.initMusic();

		this._music.mainMusic1 = this.loader.getSound('resources/sounds/music/music_main_1.mp3');
		this._music.mainMusic2 = this.loader.getSound('resources/sounds/music/music_main_2.mp3');
		this._music.mainMusic3 = this.loader.getSound('resources/sounds/music/music_main_3.mp3');
		this._music.freeSpinsMusic = this.loader.getSound('resources/sounds/music/music_fs.mp3');
	}

	protected initVoice(): void {
		super.initVoice();
	}
}



// WEBPACK FOOTER //
// ./src/sound/GameSoundManager.ts